module.exports = __webpack_public_path__ + "media/Social/Linkedin-ed82d8f1.svg";